<template>
  <a
    :href="mattermostLink"
    target="_blank"
    class="no-underline text-black hover:text-black"
    data-test-mattermost-link
  >
    <button class="flex items-center ml-2 font-sans text-lg">
      <SvgIcon
        name="mattermost"
        class="w-6 h-6 fill-transparent"
        aria-hidden="true"
      />
      <div class="ml-3">
        {{ $t("general.mattermost") }}
      </div>
    </button>
  </a>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import { useAuthStore } from "@/store/Auth";
import { useRuntimeEnv } from "@core/src/helpers/environment";

const runtimeEnv = useRuntimeEnv();

const authStore = useAuthStore();

const mattermostLink = computed(() => {
  return `${runtimeEnv.VITE_MATTERMOST_URL}/${authStore.activeTenant}`;
});
</script>
